import { RouterProvider } from 'react-router-dom';
import { useConfig } from 'providers/config/ConfigProvider';
import { createRouter } from './create-router';

export const AppRoutes = () => {
  const { routerBasePath: basename } = useConfig();

  return (
    <div className='app-content'>
      <RouterProvider router={createRouter(basename)} />
    </div>
  );
};
